import React from 'react'
import { useLocation } from 'react-router'

import { Tab } from '../../../design-system/Tab'
import { useBotId } from '../../../../store/flow'
import { DisableableLink } from '../../../Styleguide/DisableableLink'

export const BotTesterTab: React.FC = () => {
  const botId = useBotId()
  const location = useLocation()

  const isActive = location.pathname.includes(`/bots/${botId}/bot-tester`)

  return (
    <DisableableLink key="bot-tester-tab" to={getScenarioListHref(botId)}>
      <Tab size={18} label="Bot tester" active={isActive} />
    </DisableableLink>
  )
}

export function getScenarioListHref(botId: string) {
  return `/bots/${botId}/bot-tester/scenarios`
}
